import { render } from "./BaseAccordionHeader.vue?vue&type=template&id=6be50f02&scoped=true&ts=true"
import script from "./BaseAccordionHeader.vue?vue&type=script&lang=ts"
export * from "./BaseAccordionHeader.vue?vue&type=script&lang=ts"

import "./BaseAccordionHeader.vue?vue&type=style&index=0&id=6be50f02&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be50f02"]])

export default __exports__